/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Kno2Execution
 */
export interface Kno2Execution {
    /**
     * 
     * @type {string}
     * @memberof Kno2Execution
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Execution
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Execution
     */
    state: Kno2ExecutionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof Kno2Execution
     */
    error?: string;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Execution
     */
    created_at: Date;
}


/**
 * @export
 */
export const Kno2ExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
    Failed: 'failed'
} as const;
export type Kno2ExecutionStateEnum = typeof Kno2ExecutionStateEnum[keyof typeof Kno2ExecutionStateEnum];


/**
 * Check if a given object implements the Kno2Execution interface.
 */
export function instanceOfKno2Execution(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function Kno2ExecutionFromJSON(json: any): Kno2Execution {
    return Kno2ExecutionFromJSONTyped(json, false);
}

export function Kno2ExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Kno2Execution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'state': json['state'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function Kno2ExecutionToJSON(value?: Kno2Execution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'state': value.state,
        'error': value.error,
        'created_at': (value.created_at.toISOString()),
    };
}

